<template>
  <div :class="['period-container flex-column', activeNav.key, programStyle]">
    <div class="tab-container">
      <div
        :class="{ tabs: true, active: activeTab ? period.period === activeTab.period : false }"
        v-for="period in periods"
        :key="period.period"
        @click="setActiveTab(period)"
      >
        <span
          v-if="period.secondaryStatusIcon && period.secondaryStatusIcon !== 'Hidden'"
          :class="['period-icon', period.secondaryStatusIcon]"
        ></span>
        <span class="period-name">{{ period.period }}</span>
        <span
          v-if="period.statusIcon && period.statusIcon !== 'Hidden'"
          :class="['period-icon', period.statusIcon]"
        ></span>
      </div>
    </div>
    <div class="warning-banner">
      <div class="warning-text" v-if="activeTab && activeTab.primaryTimePeriodMessage">
        <img src="@/assets/new/warning_white.png" />
        <span>{{ activeTab.primaryTimePeriodMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Periods',
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState('global', ['programStyle']),
    ...mapState(['periods']),
    ...mapState({
      activeTab: 'activePeriod',
      activeNav: 'activeNavTab',
    }),
    period() {
      return this.activeTab.period;
    },
  },
  watch: {},
  methods: {
    setActiveTab(newTab) {
      this.$store.state.activePeriod = newTab;
      this.$emit('getNewInfo');
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  display: flex;
  min-height: 40px;
  &.Pillars {
    top: 118px !important;
  }
}
.period-container {
  position: sticky;
  top: 0px;
  z-index: 4;
  background: #c3c5d0;
  min-height: 40px;
  width: 100%;
  border-bottom: 5px #243882 solid;
  filter: drop-shadow(0px 3px 6px #00000029);
}
.Pillars {
  top: 122px;
}
.tabs {
  display: flex;
  flex-direction: row;
  width: 100%;
  color: #1d1d1b;
  align-items: center;
  background-color: #d3d3d36c;
  justify-content: center;
  position: relative;
  padding-top: 5px;
  cursor: pointer;
  &:not(:last-of-type) {
    border-right: 1px solid #24388280;
  }
  .pillar-icon {
    height: 35px;
    width: 35px;
    padding-right: 10px;
  }
  .incentive-icon {
    width: 24px;
    height: 24px;
    padding: 5px 5px 5px 15px;
  }
  &.active {
    background-color: #243882;
    color: white;
  }
}
.period-name {
  margin: 0px 5px;
}
.period-icon {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  border: 1px solid white;
  &.N {
    background-color: #8a8c8d;
  }
  &.C {
    background-color: $fca-orange;
  }
  &.P {
    background-color: #038717;
  }
  &.F {
    background-color: #eb0001;
  }
  &.X {
    background-color: #c4c5c6;
  }
  &.FP {
    background-color: #597dd9;
  }
  &.A {
    background-color: #e4bd35;
  }
  &.I {
    background-color: #6d20be;
  }
  &.L {
    background-color: #ff6261;
  }
}
</style>
